<!-- Preloader -->
<div *ngIf="isSpinning == true" class="preloader">
    <div class="preloader-inner">
        <nz-spin [nzSpinning]="isSpinning" nzSimple [nzSize]="'large'" nzTip="{{loadingSpinner}}"></nz-spin>
    </div>
</div>
<section  [ngClass]="!step3 ? 'bgblue-tablet' : 'bggrey-tablet'">
    <section class="hero-area">
        <header>
            <div class="px-4 py-2">
                <div class="container-fluid">
                    <div class="relative -mx-4 flex items-center justify-between">
                        <div class="text-white flex w-full items-center justify-between"
                            (dblclick)="toggleFullscreen()">
                            <img *ngIf="!step3" alt="Brand" src="assets/images/logo.svg" class="img img-fluid">
                            <img *ngIf="step3" alt="Brand" src="assets/images/logoblue.svg" class="img img-fluid">
                        </div>
                        <div class="w-50 max-w-full" *ngIf="isMultiLanguage && step1">
                            <div class="btn-lang float-right">
                                <div class="cell-btn" [ngClass]="!isEnglish ? 'active' : ''">
                                    <a (click)="changeLanguage(false)">
                                        <img alt="Brand" src="assets/images/vn.svg" class="img-fluid">
                                    </a>
                                </div>
                                <div class="cell-btn" [ngClass]="isEnglish ? 'active' : ''">
                                    <a (click)="changeLanguage(true)">
                                        <img alt="Brand" src="assets/images/en.svg" class="img-fluid">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    </section>
    <section class="bg-gray" *ngIf="step1">
        <div class="px-4 mt-5">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="boxService">
                            <div class="row">
                                <div class="col-12">
                                    <div class="textPlease text-center">
                                        {{welcomeContent}}<br>
                                        <span>{{chooseProduct}}</span>
                                    </div>
                                </div>
                            </div>
                            <!-- spdv -->
                            <div class="row">
                                <ng-container *ngIf="splitTypeCus">
                                    <!--boxtab -->
                                    <div class="boxtab">
                                        <div class="row">
                                            <div class="col-12 col-sm-12 col-lg-12">
                                                <ul class="nav nav-pills" id="pills-tab" role="tablist">
                                                    <li class="nav-item" role="presentation">
                                                        <a class="nav-link active" id="pills-home-tab" data-bs-toggle="pill"
                                                            data-bs-target="#pills-home" type="button" role="tab"
                                                            aria-controls="pills-home" aria-selected="true">
                                                            <span class="tab-iconCN"></span> CÁ NHÂN
                                                        </a>
                                                    </li>
                                                    <li class="nav-item" role="presentation">
                                                        <a class="nav-link" id="pills-profile-tab" data-bs-toggle="pill"
                                                            data-bs-target="#pills-profile" type="button" role="tab"
                                                            aria-controls="pills-profile" aria-selected="false">
                                                            <span class="tab-iconDN"></span> DOANH NGHIỆP
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <!--end boxtab -->
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="tab-content" id="pills-tabContent">
                                                <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                                                    aria-labelledby="pills-home-tab" tabindex="0">
                                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4"
                                                        *ngFor="let grp of lstgroup"
                                                        (click)="selectedService(grp.id);$event.stopPropagation()">
                                                        <div *ngIf="grp.groupName == 'CN'" class="service_item_container">
                                                            <div class="single-item">
                                                                <div class="icon">
                                                                    <img src="assets{{ grp.iconPath }}" alt="icon"
                                                                        class="iconHeight img-fluid">
                                                                    <i class="lni lni-grid-alt"></i>
                                                                </div>
                                                                <h4 class="title">
                                                                    {{ isEnglish ? grp.nameEn :grp.name }}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="tab-pane fade" id="pills-profile" role="tabpanel"
                                                    aria-labelledby="pills-profile-tab" tabindex="0">
                                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4"
                                                        *ngFor="let grp of lstgroup"
                                                        (click)="selectedService(grp.id);$event.stopPropagation()">
                                                        <div *ngIf="grp.groupName == 'DN'" class="service_item_container">
                                                            <div class="single-item">
                                                                <div class="icon">
                                                                    <img src="assets{{ grp.iconPath }}" alt="icon"
                                                                        class="iconHeight img-fluid">
                                                                    <i class="lni lni-grid-alt"></i>
                                                                </div>
                                                                <h4 class="title">
                                                                    {{ isEnglish ? grp.nameEn :grp.name }}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="!splitTypeCus">
                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4" *ngFor="let grp of lstgroup"
                                        (click)="selectedService(grp.id)">
                                        <div class="service_item_container">
                                            <div class="single-item">
                                                <div class="icon">
                                                    <img src="assets{{ grp.iconPath }}" alt="icon" class="iconHeight img-fluid">
                                                    <i class="lni lni-grid-alt"></i>
                                                </div>
                                                <h4 class="title">{{isEnglish ? grp.nameEn :grp.name }}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- end spdv -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="bg-gray" *ngIf="step2">
        <div class="px-4 mt-5">
            <div class="container-fluid mt-5 pt-5">
                <div class="row">
                    <div class="col-12">
                        <div class="textWel text-center">{{ inputPlaceholder }}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-10 offset-sm-1">
                        <div class="boxInput">
                            <div class="form-group row">
                                <div class="col-12">
                                    <input type="text" id="search-markets" #strSearch [(ngModel)]="strFilter" name="strFilter"
                                        required pattern="^(84|0[1-9])[0-9]{8}$|^(\d{12})$"
                                        class="input-field form-control" (focus)="checkUpdateFilter();onSearchFocus()"
                                        inputmode="none">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="isShowQRCode">
                    <!-- QR -->
                    <div class="justify-content-md-center mb-3 mt-2">
                        <div class="col col-lg-4">
                            <div class="serviceQR">
                                <div class="icon">
                                    <img src="assets/images/qr-KSQD.png" alt="icon" class="iconHeight-qr img-fluid">
                                </div>
                                <div class="service-content">
                                    <h3>{{bankRegulations}}</h3>
                                </div>
                            </div>
                        </div>
                        <div class="col col-lg-4">
                            <div class="serviceQR">
                                <div class="icon">
                                    <img [src]="surveyQr" alt="icon" class="iconHeight-qr img-fluid">
                                </div>
                                <div class="service-content">
                                    <h3>{{ratingService}}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--  ens QR -->
                </div>
            </div>
        </div>

        <!-- btn back -->
        <a href="javascript:void(0)" class="scroll-back" (click)="backtoHome()">
            <img src="assets/images/arrow-left.svg" alt="#" style="width: 24px;padding-right: 5px"><span>{{ getBackToHome }}<span *ngIf="isValid">({{remainingTime}}s)</span></span>
        </a>
        <!-- end btn back -->
    </section>
    <section class="bg-gray pt-5" *ngIf="step3">
        <div class="px-4 pt-5">
            <div class="container-fluid pt-3">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        <div class="box-stt">
                            <div class="content-text">{{queueNumber}}</div>
                            <div [ngClass]="isPiority || (customer && customer.isPriority)  ? 'text-stt' : 'text-sttUn'">
                                <span>{{queuestt}}</span>
                                <div class="content-exit text-center">{{notificationOnPhone}}</div>
                                <div class="text-center">
                                    <img *ngIf="!isZaloChannel" src="assets/images/spay.png" alt="icon" style="display: inline-block; height: 64px;">
                                    <img *ngIf="isZaloChannel" src="assets/images/zalo.png" alt="icon" style="display: inline-block; height: 64px;">
                                </div>
                            </div>
                        </div>
                        <div class="table-container">
                            <table width="100%" cellspacing="0" cellpadding="0" [border]="0" style="border-collapse:collapse" class="tableKH">
                                <tbody>
                                    <tr>
                                        <td class="text-right" width="40%">{{offical}}</td>
                                        <td class="text-left" width="60%">{{isEnglish ? branchNameEn : branchName | uppercase }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-right">{{customerEn}}</td>
                                        <td class="text-left text-end">{{ customerName | uppercase }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-right">{{service}}</td>
                                        <td class="text-left text-end">{{ productName | uppercase }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="text-center">
                            <a class="btntimeBlue" (click)="reset(true)">{{close}} ({{remainingTime}}s)</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>

<!-- Modal show -->
<div class="modal fade" appBsModal #warningModal="bs-modal" role="dialog" aria-hidden="true"
    (click)="closeModalWarning(false);$event.stopPropagation()">
    <div class="modal-dialog modal-dialog-centered modal-fullscreen-md-down">
        <div class="modal-content-load_exit modal-content" (click)="$event.stopPropagation()">
            <div class="modal-body text-center">
                <div class="box-exit">
                    <div class="img-exit text-center">
                        <img src="assets/images/alert.png" alt="icon" class="img-fluid">
                    </div>
                    <div class="name-exit text-center">{{titleAlert}}</div>
                    <div class="content-exit text-center">{{contentAlert}}</div>
                </div>
            </div>
            <!--btn time -->
            <div class="box-btntime">
                <button class="btntime" (click)="closeModalWarning(false);$event.stopPropagation()"
                    data-bs-dismiss="modal">
                    {{close}} ({{remainingTime}}s)
                </button>
            </div>
        </div>
    </div>
</div>
<!-- end Modal show -->

<!--show div -->
<div class="container-fluid box-place" (click)="$event.stopPropagation()" (touchend)="$event.stopPropagation()">
    <div id="main-display">
        <div id="select-markets" class="row select-filters select-markets-filters" [hidden]="!this.isShowKeyBoard ">
            <div class="col-sm-10 offset-sm-1">
                <div class="row">
                    <div class="col-md-3">
                        <!-- key -->
                        <div class="classic-testimonials" (click)="onKeyBoardPress('1')">
                            <div class="testimonial-content">
                                <p class="text-key"><a>1</a></p>
                            </div>
                        </div>
                        <!-- End key -->
                    </div>
                    <div class="col-md-3">
                        <!-- key -->
                        <div class="classic-testimonials" (click)="onKeyBoardPress('2')">
                            <div class="testimonial-content">
                                <p class="text-key"><a>2</a></p>
                            </div>
                        </div>
                        <!-- End key -->
                    </div>
                    <div class="col-md-3">
                        <!-- key -->
                        <div class="classic-testimonials" (click)="onKeyBoardPress('3')">
                            <div class="testimonial-content">
                                <p class="text-key"><a>3</a></p>
                            </div>
                        </div>
                        <!-- End key -->
                    </div>
                    <div class="col-md-3">
                        <!-- key -->
                        <div class="classic-testimonials" (click)="onKeyBoardPress('4')">
                            <div class="testimonial-content">
                                <p class="text-key"><a>4</a></p>
                            </div>
                        </div>
                        <!-- End key -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <!-- key -->
                        <div class="classic-testimonials" (click)="onKeyBoardPress('5')">
                            <div class="testimonial-content">
                                <p class="text-key"><a>5</a></p>
                            </div>
                        </div>
                        <!-- End key -->
                    </div>
                    <div class="col-md-3">
                        <!-- key -->
                        <div class="classic-testimonials" (click)="onKeyBoardPress('6')">
                            <div class="testimonial-content">
                                <p class="text-key"><a>6</a></p>
                            </div>
                        </div>
                        <!-- End key -->
                    </div>
                    <div class="col-md-3">
                        <!-- key -->
                        <div class="classic-testimonials" (click)="onKeyBoardPress('7')">
                            <div class="testimonial-content">
                                <p class="text-key"><a>7</a></p>
                            </div>
                        </div>
                        <!-- End key -->
                    </div>
                    <div class="col-md-3">
                        <!-- key -->
                        <div class="classic-testimonials" (click)="onKeyBoardPress('8')">
                            <div class="testimonial-content">
                                <p class="text-key"><a>8</a></p>
                            </div>
                        </div>
                        <!-- End key -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <!-- key -->
                        <div class="classic-testimonials" (click)="onKeyBoardPress('9')">
                            <div class="testimonial-content">
                                <p class="text-key"><a>9</a></p>
                            </div>
                        </div>
                        <!-- End key -->
                    </div>
                    <div class="col-md-3">
                        <!-- key -->
                        <div class="classic-testimonials" (click)="onKeyBoardPress('0')">
                            <div class="testimonial-content">
                                <p class="text-key"><a>0</a></p>
                            </div>
                        </div>
                        <!-- End key -->
                    </div>
                    <div class="col-md-3">
                        <!-- key -->
                        <div class="classic-testimonials" (click)="onKeyBoardPress('delete')">
                            <div class="testimonial-content">
                                <p class="text-key"><a>{{ keyboarDelete }}</a></p>
                            </div>
                        </div>
                        <!-- End key -->
                    </div>
                    <div class="col-md-3">
                        <!-- key -->
                        <div class="classic-testimonials" [class.disabled]="isSpinning" (click)="onKeyBoardPress('enter')">
                            <div class="testimonial-content">
                                <p class="textBlue"><a>{{ keyboarComplete }}</a></p>
                            </div>
                        </div>
                        <!-- End key -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--show div -->